import React from 'react';

interface PostCardProps {
    postCard: {
        postCardId: number;
        postCardPhoto: string;
    };
    onClick?: () => void;
}

const PostCard: React.FC<PostCardProps> = ({ postCard, onClick }) => {
    const imgSrc = postCard.postCardPhoto
        ? `data:image/png;base64,${postCard.postCardPhoto}`
        : `${process.env.PUBLIC_URL}/img/book_5.jpg`;

    return (
        <div
            className="w-[275px] h-[369px] md:w-[105px] md:h-[141px] gap-2 bg-gray-200 rounded-lg cursor-pointer flex flex-col mb-10"
            onClick={onClick}
        >
            <img
                src={imgSrc}
                alt=""
                className="w-full h-full object-cover rounded-lg shadow-md"
            />
        </div>
    );
};

export default PostCard;
